import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { WORKGROUPS_PRIVATE_REASON_MIN_LEN } from '@/stores/workgroups-ui-store';

interface PrivateAccessReasonDialogProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  onSubmit: (reason: string) => void;
  dismissible?: boolean;
}

export function PrivateAccessReasonDialog({
  open,
  onOpenChange,
  onSubmit,
  dismissible = false,
}: PrivateAccessReasonDialogProps) {
  const [reason, setReason] = useState('');
  const trimmed = reason.trim();
  const valid = trimmed.length >= WORKGROUPS_PRIVATE_REASON_MIN_LEN;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!valid) return;
    onSubmit(trimmed);
    setReason('');
  };

  return (
    <Dialog open={open} onOpenChange={dismissible ? onOpenChange : undefined}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Private work group access</DialogTitle>
          <DialogDescription>
            You are opening another user&apos;s private work group as an administrator. Enter a
            reason (at least {WORKGROUPS_PRIVATE_REASON_MIN_LEN} characters). This is logged by the
            backend and is not stored permanently in the browser.
          </DialogDescription>
        </DialogHeader>
        <form className="space-y-2" onSubmit={handleSubmit}>
          <Label htmlFor="wg-private-reason">Access reason</Label>
          <Input
            id="wg-private-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Support ticket or business justification"
            autoComplete="off"
          />
          <DialogFooter>
            <Button type="submit" disabled={!valid}>
              Continue
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
